export default "__VITE_ASSET__360d0e0c__"